// Theme colors
export const FLEETY_BLUE = "#3FA9F5";
export const CHART_COLORS = ["#3FA9F5", "#10B981", "#F59E0B", "#EF4444", "#8B5CF6", "#EC4899"];

// Status color mapping
export const STATUS_COLORS = {
  placed: "bg-blue-100 text-blue-800",
  confirmed: "bg-cyan-100 text-cyan-800",
  preparing: "bg-yellow-100 text-yellow-800",
  ready: "bg-purple-100 text-purple-800",
  accepted: "bg-indigo-100 text-indigo-800",
  rider_assigned: "bg-indigo-100 text-indigo-800",
  picked_up: "bg-orange-100 text-orange-800",
  delivered: "bg-green-100 text-green-800",
  cancelled: "bg-red-100 text-red-800",
  open: "bg-red-100 text-red-800",
  approved: "bg-green-100 text-green-800",
  partial_refund: "bg-yellow-100 text-yellow-800",
  rejected: "bg-gray-100 text-gray-800",
  resolved: "bg-blue-100 text-blue-800",
  pending: "bg-yellow-100 text-yellow-800",
  completed: "bg-green-100 text-green-800",
  failed: "bg-red-100 text-red-800",
  processing: "bg-blue-100 text-blue-800",
  in_review: "bg-yellow-100 text-yellow-800",
  on_hold: "bg-orange-100 text-orange-800",
};
